import type { ButtonSizes } from './types';

/** opacity when form in disabled state */
export const DISABLED_OPACITY = '0.4';

export const SIZES = ['xs', 'sm'] as const;

export const BUTTON_SIZES: ButtonSizes = {
  xs: {
    fontVariant: 'bodyBold12',
    height: '30px',
  },
  sm: {
    fontVariant: 'bodyBold14',
    height: '52px',
  },
};
